import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { ApiUrlConstants } from 'src/app/shared/common/ApiUrlConstants';
import {
  KycCertification,
  KycDashboardRow,
  KycDocument,
  KycLookups,
  KycMaster,
  KycTimelineEntry,
} from './kyc.service';

/**
 * Angular service for the buyer KYC backend (Jira MPS-193).
 * Hits the dedicated buyer module endpoints so buyer KYC data
 * never intermixes with supplier KYC data.
 */
@Injectable({ providedIn: 'root' })
export class BuyerKycService {
  constructor(private webApi: WebApiService) {}

  getLookups(): Promise<KycLookups> {
    return this.webApi.getRequest<KycLookups>(ApiUrlConstants.buyerKycGetLookups);
  }

  getDashboard(buyerId: number): Promise<{ rows: KycDashboardRow[] }> {
    return this.webApi.getRequest<{ rows: KycDashboardRow[] }>(
      `${ApiUrlConstants.buyerKycGetDashboard}/${buyerId}`
    );
  }

  getApplication(
    kycId: number,
    buyerId: number
  ): Promise<{
    master: KycMaster;
    documents: KycDocument[];
    certifications: KycCertification[];
  }> {
    return this.webApi.getRequest(
      `${ApiUrlConstants.buyerKycGetApplication}/${kycId}/${buyerId}`
    );
  }

  getTimeline(kycId: number): Promise<{ history: KycTimelineEntry[] }> {
    return this.webApi.getRequest<{ history: KycTimelineEntry[] }>(
      `${ApiUrlConstants.buyerKycGetTimeline}/${kycId}`
    );
  }

  startKyc(payload: {
    buyerId: number;
    companyId?: number | null;
  }): Promise<{ kycId: number; kycReferenceNumber: string; status: string }> {
    return this.webApi.postRequest(ApiUrlConstants.buyerKycStart, payload);
  }

  saveOrg(payload: any): Promise<any> {
    return this.webApi.postRequest(ApiUrlConstants.buyerKycSaveOrg, payload);
  }

  saveBanking(payload: any): Promise<any> {
    return this.webApi.postRequest(ApiUrlConstants.buyerKycSaveBanking, payload);
  }

  saveDocument(payload: any): Promise<any> {
    return this.webApi.postRequest(ApiUrlConstants.buyerKycSaveDocument, payload);
  }

  saveCertification(payload: any): Promise<any> {
    return this.webApi.postRequest(ApiUrlConstants.buyerKycSaveCertification, payload);
  }

  submit(payload: { kycId: number; statusNote?: string }): Promise<any> {
    return this.webApi.postRequest(ApiUrlConstants.buyerKycSubmit, payload);
  }
}
